import { createAction, props } from '@ngrx/store';
import { ProjectJobServiceCreateResponseJson } from '@vmspdb/definitions';

export const loadProjectJobs = createAction(
  '[ProjectJobs] Load ProjectJobs',
  props<{ projectUuid: string }>(),
);

export const setProjectJobs = createAction(
  '[ProjectJobs] Set ProjectJobs',
  props<{
    projectJobs: ProjectJobServiceCreateResponseJson[];
  }>(),
);
